module.exports = __webpack_public_path__ + "img/management-share-3.5db221a2.png";